/*
 * @Auther: 罗耀祖
 * @Date: 2022-04-09 13:36:11
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-04-09 13:40:45
 * @name: 用户信息
 * @Description: 用户信息
 * @FilePath: \project\src\store\modules\user.js
 * @Author: desktop
 */
const state = {
  userInfo: [], //用户信息
}

const mutations = {
  // 修改保存的用户信息commit
  CHANGE_USERINFO(state, userInfo) {
    state.userInfo = userInfo;
  },
}

const actions = {
  // 修改保存的用户信息dispatch
  changeUserInfo({ commit }, userInfo) {
    commit('CHANGE_USERINFO', userInfo)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}